//@ts-check
import React from "react";

/**
 * Reads a CSS custom property and normalizes it to a 6-digit hex color string.
 * @param {Element} element
 * @param {string} property
 * @returns {string|null}
 */
function componentPropToHex(element, property) {
    function RGBtoHex(decimals) {
        if (!Array.isArray(decimals) || decimals.length < 3) 
            return null;

        return `${decimals.map((d) => d.toString(16).padStart(2, '0')).join('')}`;
    }

    function parseRGBString(rgbString) {
        const result = rgbString.match(/\d+\.?\d+/g);
        if (result) {
            return result.map(e => parseInt(e));
        }
        return null;
    }

    const bgColorRGB = getComputedStyle(element).getPropertyValue(property).trim();
    const parsedRGB = parseRGBString(bgColorRGB);
    return RGBtoHex(parsedRGB);
}

/**
 * 
 * @param {{src: string, className?: string, alt: string, children?: any }} props 
 */
const UserImg = ({src, className, alt, children}) => {
    if(src === null || src === ""){
        return null;
    }
    
    /**
     * This color will be bg color for initials avatar if no image exists. see the value at CSS > :root > --user-bg-color
     */
    const bgColor = componentPropToHex(document.documentElement, '--user-bg-color');
    const sign = src.indexOf("?") === -1 ? "?" : "&";
    const url = `${src}${sign}color=${bgColor}`;

    return <img className={ className } src={url} alt={alt}/>

}
export default UserImg;